module.exports = __webpack_public_path__ + "img/frame (89).7e1bddaa.jpg";